import React from "react";

class Clock extends React.Component {
  render() {
    let clock;

    if (this.props.simulationTime) {
      let hours = this.props.simulationTime.hours || 0;
      let minutes = this.props.simulationTime.minutes || 0;

      const size = this.props.size || 200;

      // Calculate angles
      const minuteAngle = minutes * 6;
      const hourAngle = (hours % 12) * 30 + minutes * 0.5;

      // Format for display
      if (hours.toString().length === 1) {
        hours = "0" + hours;
      }
      if (minutes.toString().length === 1) {
        minutes = "0" + minutes;
      }

      clock = (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: size * 0.1,
            padding: size * 0.1,
            fontFamily: "sans-serif",
          }}
        >
          {/* Clock Face */}
          <div
            style={{
              position: "relative",
              width: size,
              height: size,
              border: `${size * 0.025}px solid #999`,
              borderRadius: "50%",
              background: "#e8e8e8",
            }}
          >
            {/* Hour tick marks */}
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                style={{
                  position: "absolute",
                  top: size * 0.04,
                  left: "50%",
                  width: size * 0.01,
                  height: size * 0.06,
                  marginLeft: -(size * 0.005),
                  background: "#000",
                  transformOrigin: `center ${size / 2 - size * 0.04}px`,
                  transform: `rotate(${i * 30}deg)`,
                }}
              />
            ))}

            {/* Hour hand */}
            <div
              style={{
                position: "absolute",
                bottom: "50%",
                left: "50%",
                width: size * 0.02,
                height: size * 0.25,
                marginLeft: -(size * 0.01),
                background: "#000",
                transformOrigin: "bottom center",
                transform: `rotate(${hourAngle}deg)`,
                borderRadius: size * 0.01,
              }}
            />

            {/* Minute hand */}
            <div
              style={{
                position: "absolute",
                bottom: "50%",
                left: "50%",
                width: size * 0.015,
                height: size * 0.375,
                marginLeft: -(size * 0.0075),
                background: "#000",
                transformOrigin: "bottom center",
                transform: `rotate(${minuteAngle}deg)`,
                borderRadius: size * 0.01,
              }}
            />

            {/* Center dot */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: size * 0.04,
                height: size * 0.04,
                margin: `${-(size * 0.02)}px 0 0 ${-(size * 0.02)}px`,
                background: "#000",
                borderRadius: "50%",
                zIndex: 1,
              }}
            />
          </div>
        </div>
      );
    }

    return (
      <div className="clock-container" style={{ colorScheme: "light" }}>
        {clock}
      </div>
    );
  }
}

export default Clock;
